export const PXTabs = (function() {
	'use strict';

	let $tabGroup;

	function init() {

		$tabGroup = $('.pxblock--tabs');
		if (!$tabGroup) return null;

		$tabGroup.each(function () {
			let $this = $(this);
			let $items = $this.find('.pxblock--tabs__item');
			$items.each(function (index) {
				if(index != 0){
					let $that = $(this);
					let $panel = $that.find('.pxblock--tabs__item-content');
					$panel.fadeOut(1);
				}
			});
		});

		events();
	}

	function events() {
		$tabGroup = $('.pxblock--tabs');
		if (!$tabGroup) return null;

		$tabGroup.each(function () {
			let $this = $(this);
			let $headings = $this.find('.pxblock--tabs__item-heading');
			let $items = $this.find('.pxblock--tabs__items');

			$headings.each(function () {
				let $that = $(this);
				let $button = $that.find('button');

				$button.on('click', function () {
					let $headingsAgain = $this.find('.pxblock--tabs__item-heading');
					$headingsAgain.each(function () {
						let $buttonAgain = $(this).find('button');
						$buttonAgain.attr('aria-expanded', 'false');
					});

					let $thisButton = $(this);
					if ($thisButton.attr('aria-expanded') === 'true') {
						$thisButton.attr('aria-expanded', 'false');
					} else {
						$thisButton.attr('aria-expanded', 'true');
					}

					let $panels = $this.find('.pxblock--tabs__item-content');
					let $buttonIndex = $thisButton.data('index');
					
					$panels.each(function () {
						$(this).hide();
						let $panelIndex = $(this).data('index')
						$(this).attr('aria-hidden', 'true');
						console.log($panelIndex, $buttonIndex)
						if($panelIndex == $buttonIndex){
							$(this).fadeIn();
							$(this).attr('aria-hidden', 'false');
						}
					});
				});
			})

			// $items.each(function () {
			// 	let $that = $(this);
			// 	let $button = $that.find('button');
			// 	let $panel = $that.find('.pxblock--tabs__item-content');

			// 	$button.on('click', function () {
			// 		let $thisButton = $(this);
			// 		if ($thisButton.attr('aria-expanded') === 'true') {
			// 			$thisButton.attr('aria-expanded', 'false');
			// 			$panel.fadeIn();
			// 			$panel.attr('aria-hidden', 'true');
			// 		} else {
			// 			$thisButton.attr('aria-expanded', 'true');
			// 			$panel.fadeIn();
			// 			$panel.attr('aria-hidden', 'false');
			// 		}
			// 	});
			// })
		})
	}

	return {
		init: init
	};
})();
